<fury-page-layout mode="card">
<div class="rangeselectorprt">
    <form [formGroup]="selectType">
            <span>
                <input type="radio" value="hourType" formControlName="type"/>
               
                <mat-form-field appearance="outline">
                    <mat-label>Select Duration</mat-label>
                    <mat-select formControlName="hourValue" [disabled]="selectType.value.type !== 'hourType'" (selectionChange)="hourRangeChange($event)">
                        <mat-option *ngFor="let hour of hours" [value]="hour.value">
                            {{hour.viewValue}}
                          </mat-option>
                    </mat-select>
                </mat-form-field>
            </span>
            <span>
                <input type="radio" value="dateType" formControlName="type"/>
                <div class="daterange">
                    <mat-form-field class="example-form-field" appearance="outline">
                    <mat-label>Date Range</mat-label>
                        <mat-date-range-input
                        [formGroup]="campaignOne"
                        [rangePicker]="campaignOnePicker"
                        [max]="today" 
                        [disabled]="selectType.value.type !== 'dateType'">
                        <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
                        <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                        </mat-date-range-input>
                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="campaignOnePicker"></mat-datepicker-toggle>
                        <mat-date-range-picker #campaignOnePicker>
                            <mat-date-range-picker-actions>
                                <button class="apply" mat-raised-button color="primary" matDateRangePickerApply>Apply</button>
                                <button class="can" mat-button matDateRangePickerCancel>Cancel</button>
                            </mat-date-range-picker-actions>
                        </mat-date-range-picker>
                    </mat-form-field>
                </div>
            </span>
    </form>
</div>
<ul class="listcont">
    <li class="pointer" (click)="changeTabName('newLeads')">
        New Leads
        <span class="green">{{dashboardDetails?.newLeads | number}}</span>
    </li>
    <li class="pointer" (click)="changeTabName('activeLeads')">
        Active Leads
        <span class="green">{{dashboardDetails?.activeLeads | number}}</span>
    </li>
<ng-container *ngIf="isAdmin">
    <li class="pointer" (click)="changeTabName('closedLeads')">
        Closed Leads
        <span class="red">{{dashboardDetails?.closedLeads | number}}</span>
    </li>
    <li class="pointer" (click)="changeTabName('badLeads')">
        Bad Leads
        <span class="red">{{dashboardDetails?.badLeads | number}}</span>
    </li>
    <li class="pointer" (click)="changeTabName('duplicateLeads')">
        Duplicate Leads
        <span class="orenge">{{dashboardDetails?.duplicateLeads | number}}</span>
    </li>
    <li class="pointer" (click)="changeTabName('validLeads')">
        Valid Leads
        <span class="orenge">{{dashboardDetails?.validLeads | number}}</span>
    </li>
    <li class="pointer" (click)="changeTabName('totalLeads')">
        Total Leads
        <span class="orenge">{{dashboardDetails?.totalLeads | number}}</span>
    </li>
    <li>
        CPA
        <span class="orenge">$ {{dashboardDetails?.cpa | number}}</span>
    </li>
</ng-container>
    <li class="pointer" (click)="changeTabName('sales')">
        Sales
        <span class="orenge">{{dashboardDetails?.sales | number}}</span>
    </li>
    <li>
        Conversion
        <span class="orenge">{{dashboardDetails?.conversion | number}} %</span>
    </li>
    <li *ngIf="!isAdmin">
        My Conversion
        <span class="blue">$ {{dashboardDetails?.myConversion | number}}</span>
    </li>
    <li *ngIf="!isAdmin">
        My Sales
        <span class="blue">$ {{dashboardDetails?.mySales | number}}</span>
    </li>
    <li *ngIf="isAdmin">
        Leads Cost
        <span class="blue">$ {{dashboardDetails?.leadCost | number}}</span>
    </li>
</ul>

    <fury-page-layout-header>
        <div class="top_heading">
                <fury-breadcrumbs [@fadeInRight]  [current]="filterValue"></fury-breadcrumbs>
                <div class="toggle" *ngIf="isAdmin">
                <span>Active Leads</span> 
                <mat-slide-toggle [(ngModel)]="isActive" (change)="changeStatus($event)"></mat-slide-toggle>
                </div>
        </div>
      
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns"  [hideSearchInput]="true">
    
        <div class="actions" *ngIf="notPostedLeadCount > 0">
            <button mat-raised-button color="accent" type="button" (click)="postUnPostedLead()">
              {{'Release' + ' ' + notPostedLeadCount + ' ' + 'leads'}}
            </button>
          </div>
          <div class="actions">
            <button  mat-raised-button class="black" (click)="openMergeAccountModal()">Change User</button>
          </div>
          <div class="table_container">
            <table class="lead_list" [dataSource]="dataSource" mat-table>
                <form [formGroup]="leadSearchForm">    
                <ng-container matColumnDef="actions" stickyEnd>
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>
                        <div>
                            <div class="search" (click)="getLeadRequestList()">
                                <mat-icon>search</mat-icon>
                            </div>
                        </div>
                        <h3>
                            Actions
                        </h3>
                    </th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item (click)="navigateDetailsPage(row)">
                                <span>View</span>
                            </button>
                            <span *ngIf="row?.source">
                                <button mat-menu-item (click)="reportGoodLead(row)" *ngIf="checkLead(row.source)">
                                    <span>Remove Error</span>
                                </button>
                                <button mat-menu-item (click)="reportBadLead(row)" *ngIf="!checkLead(row.source)">
                                    <span>Report Error</span>
                                </button>
                                <button mat-menu-item (click)="reportFlagLead(row)" *ngIf="!row.source.includes('FLAG')">
                                    <span>Flag Lead</span>
                                </button>
                                <button mat-menu-item (click)="removeFlagLead(row)" *ngIf="row.source.includes('FLAG')">
                                    <span>Remove Flag</span>
                                </button>
                                <button mat-menu-item (click)="removeAllFlagLead(row)" *ngIf="row.source.includes('FLAG')">
                                    <span>Remove All Flag</span>
                                </button>
                            </span>
                        </mat-menu>
                    </td>
                </ng-container>
    
                <ng-container matColumnDef="select" sticky>
                    <th class="header-check" mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                      </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)">
                      </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="addedOn" sticky>
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div>
                                &nbsp;
                            </div>
                            <h3>
                                Added On
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{commonService.convertDate(element?.addedOn) | date : 'MMM-dd-YYYY h:mm a'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="First Name"  formControlName="firstName"/>
                            <h3>
                                First Name
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.firstName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Last Name" formControlName="lastName"/>
                            <h3>
                                Last Name
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.lastName}}
                    </td>
                </ng-container>
                    <ng-container matColumnDef="verifiedName">
                        <th mat-header-cell *matHeaderCellDef>
                            <div>
                                <input type="text" placeholder="Verified Name" formControlName="verifiedName"/>
                                <h3>
                                    Verified Name
                                </h3>
                            </div>
                            
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element?.verifiedName}}
                        </td>
                    </ng-container>
                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Email Address" formControlName="emailAddress"/>
                            <h3>
                                Email Address
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.emailAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="mobileNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Mobile No" formControlName="mobileNumber" mask="0*"/>
                            <h3>
                                Mobile No
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.mobileNumber | mask : "(000) 000-0000"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="source">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Source" formControlName="source"/>
                            <h3>
                                Source
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.source}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Address" formControlName="address"/>
                            <h3>
                                Address
                            </h3>
                        </div>
                    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.streetAddress}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="city">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="City"  formControlName="city"/>
                            <h3>
                                City
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.city}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="State" formControlName="state"/>
                            <h3>
                                State
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.stateName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="zipCode">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Zip Code"  formControlName="zip" mask="0*"/>
                            <h3>
                                Zip Code
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.address?.zip}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="attempts">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Attempts"  formControlName="attempts"/>
                            <h3>
                                Attempts
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.attempts}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="resultCode">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Result Code"  formControlName="resultCode"/>
                            <h3>
                                Result Code
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.resultCode}}
                    </td>
                </ng-container>
                  <ng-container matColumnDef="soldAmount">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div style="height: 50px;">
                                &nbsp;
                            </div>
                            <h3>
                                Total Cost
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.soldAmount | currency}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="vanillaSoftStatus">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Status"  formControlName="status"/>
                            <h3>
                                Status
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.vanillaSoftStatus}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="lastAgentName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <input type="text" placeholder="Last Agent Name"  formControlName="lastAgentName"/>
                            <h3>
                                Last Agent Name
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.lastAgentName ? element?.lastAgentName : ''}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="submission">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div style="height: 50px;">
                                &nbsp;
                            </div>
                            <h3>
                                Submission
                            </h3>
                        </div>
                    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.submission?.ipAddress}} (IP), {{element?.submission?.mobileNumber}} (P), {{element?.submission?.emailAddress}} (E)
                    </td>
                </ng-container>
                <ng-container matColumnDef="vanillaSoftTimestamps">
                    <th mat-header-cell *matHeaderCellDef>
                        <div>
                            <div style="height: 50px;">
                                &nbsp;
                            </div>
                            <h3>
                                Last Updated
                            </h3>
                        </div>
                        
                    </th>
                    <td mat-cell *matCellDef="let element">
                    {{commonService.convertDate(element?.vanillaSoftTimestamps) | date : 'MMM-dd-YYYY h:mm a'}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="leadStatus">
                    <th *matHeaderCellDef mat-header-cell>
                        <div style="height: 50px;">
                            &nbsp;
                        </div>
                        <h3>
                            Vanilla Soft Status
                        </h3>
                    </th>
                    <td *matCellDef="let element" mat-cell>
                        <mat-icon [ngStyle]="{'color': element?.postedFromVanillaSoft ? 'blue' : 'black'}">{{element?.isBlocked ? (element?.vanillaSoftUpdatedStatus ? 'done_all' : 'block') : 'task_alt'}}</mat-icon>
                    </td>
                </ng-container>
                <ng-container matColumnDef="thirdPartyStatus">
                    <th *matHeaderCellDef mat-header-cell>
                        <div style="height: 50px;">
                            &nbsp;
                        </div>
                        <h3>
                            3rd Party Status
                        </h3>
                    </th>
                    <td *matCellDef="let element" mat-cell>
                        <mat-icon>{{element?.thirdPartyStatus ? 'task_alt' : 'block'}}</mat-icon>
                    </td>
                </ng-container>
               <tr mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></tr>
                <tr *matRowDef="let row; columns: visibleColumns"
                    class="clickable route-animations-elements" mat-row>
                </tr>
            </form> 
            </table>
          </div>
        
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No Leads found.
        </div>
    <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig] = "selectConfig"
        [ngClass]="{'mat-pegig': pageSize === 9999}"
        aria-label="Select page of periodic elements">
    </mat-paginator>
    
  
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  

